import ApiService from "../api.services";

const PdvClientService = {
  list: async function () {
    try {
      const response = await ApiService.get(`/api/pdv/clients`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  add: async function (form) {
    try {
      const response = await ApiService.post(`/api/pdv/clients`, form);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default PdvClientService;

export { PdvClientService };
